import React from 'react';
import ReactMarkdown from 'react-markdown';

import { Box } from '@mui/material';

const normalizeContent = (input) => {
  if (!input) return '';
  return input
    .replace(/<br\s*\/?>/gi, '\n') // Convert <br> to newlines
    .replace(/\r\n|\r|\n/g, '\n') // Normalize all line endings
    .replace(/(\d+)\.(?=\S)/g, '$1. ') // Ensure space after "1." if missing
    .replace(/(?<=\d\..+)\n(?=\d+\.)/g, '\n\n'); // Add blank line between numbered items
};

const isHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

const MarkdownRenderer = ({ content }) => {
  if (!content) return null;

  const cleanedContent = normalizeContent(content);
  return (
    <Box
      sx={{
        fontSize: '1.125rem',
        lineHeight: 1.7,
        color: 'text.primary',
        fontFamily: 'inherit',
        '& table': {
          borderCollapse: 'collapse',
          width: '100%',
          mt: 2,
        },
        '& th, & td': {
          border: '1px solid #ccc',
          padding: '8px',
          textAlign: 'justify',
        },
        '& ul, & ol': {
          paddingLeft: '20px',
          marginBottom: '1em',
        },
        '& a': {
          color: 'primary.main',
          textDecoration: 'underline',
          wordBreak: 'break-word',
          fontSize: '1rem',
          lineHeight: 1.6,
          fontWeight: 400,
          display: 'inline',
          verticalAlign: 'baseline',
          textAlign: 'justify',
          letterSpacing: '0.25px',
        },
        '& p': {
          my: 0.5,
          textAlign: 'justify',
        },
      }}
    >
      {isHTML(cleanedContent) ? (
        // Render raw HTML safely
        <div dangerouslySetInnerHTML={{ __html: cleanedContent }} />
      ) : (
        // Render Markdown
        <ReactMarkdown>{cleanedContent}</ReactMarkdown>
      )}
    </Box>
  );
};

export default MarkdownRenderer;
